export enum TooltipTheme {
  DARK = 'dark',
  LIGHT = 'light',
}
